// extracted by mini-css-extract-plugin
export var body = "twoColumn-module--body--1eadd";
export var bodyText = "twoColumn-module--bodyText--f1059";
export var eyebrow = "twoColumn-module--eyebrow--69a27";
export var grid = "twoColumn-module--grid--ce002";
export var gridMedia = "twoColumn-module--gridMedia--aeb9b";
export var gridText = "twoColumn-module--gridText--f9c39";
export var gridTextLower = "twoColumn-module--gridTextLower--7e527";
export var headline = "twoColumn-module--headline--5114f";
export var left = "twoColumn-module--left--f9e9a";
export var lemon = "twoColumn-module--lemon--8fa42";
export var poppy = "twoColumn-module--poppy--c0c9d";
export var pricingCustomGridMedia = "twoColumn-module--pricingCustomGridMedia--45d91";
export var right = "twoColumn-module--right--07270";
export var subtext = "twoColumn-module--subtext--4862e";